<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h2 class="fmtitle">Prefatory Note</h2>
<p class="noindent">This little book has been designed for the many persons here as well as abroad who would like to get a clearer picture of the inner motives, the personal outlook and the social philosophy of the President.</p>
<p class="indent">The editor has gone through the massive body of the available papers and utterances of Mr. Roosevelt and has drawn from them statements of the underlying principles and the fundamental faith that seem to have impelled the actions of this unusual man. These statements are to be found within the texture of the many discussions on various phases of public policy. Sometimes as a brief assertion of a compelling cause of action, sometimes almost as a casual aside, the words lead beyond the momentary issue to assertion of an abiding faith.</p>
<p class="indent">This faith, combined with a deep-felt social philosophy and concern for human needs and aspirations, has from Jefferson and Lincoln to Roosevelt shaped the American way of life.</p>
<p class="noindentr">D.D.R.</p>
<a id="page_viii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Prefatory.vue?48013856